<template>
  <div class="guides-content">
    <div class="guides-table">
      <el-table
        border
        highlight-current-row
        :header-cell-style="{ background: '#f5f7fa' }"
        v-for="(item, index) in list"
        :key="index"
        :data="item"
        @row-click="handleRowClick"
      >
        <el-table-column prop="radio" width="40" align="center">
          <template slot-scope="scope">
            <el-radio :disabled="!scope.row.can_assign" v-model="guide_id" :label="scope.row.id">
            </el-radio>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="导游姓名" width="80" align="center">
          <template slot-scope="scope">
            <p :class="scope.row.can_assign ? '' : 'p-disabled'">{{ scope.row.name }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="interval_time" label="场次" width="70" align="center">
          <template slot-scope="scope">
            <p :class="scope.row.can_assign ? '' : 'p-disabled'">{{ scope.row.interval_time }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="project_name" label="项目" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <p :class="scope.row.can_assign ? '' : 'p-disabled'">{{ scope.row.project_name }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="curr_user_num" label="团队情况" minWidth="80">
          <template slot-scope="scope">
            <p :class="scope.row.can_assign ? '' : 'p-disabled'">
              已拼{{ scope.row.curr_user_num }}人
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-button
      type="primary"
      class="btn"
      v-if="(orders.length > 0) & (list.length > 0)"
      @click="handleGuide"
      >确认派单</el-button
    >
  </div>
</template>

<script>
import { postGuidesWith, postGuidesAssign } from '@/api/service'
export default {
  name: 'GuidesTable',
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    trip_type: {
      type: Number,
      default: null
    },
    keyword: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      all: [],
      list: [],
      guide_id: null
    }
  },
  mounted() {},
  methods: {
    _splitArray(arr, num) {
      let len = Math.ceil(arr.length / num)
      let newArr = []
      for (let i = 0; i < arr.length; i += len) {
        newArr.push(arr.slice(i, i + len))
      }
      return newArr
    },
    _filter(arr) {
      const kw = (this.keyword || '').trim()
      if (!kw) return arr
      return Array.isArray(arr) ? arr.filter((item) => (item.name || '').includes(kw)) : []
    },
    fetchData(orders, trip_type) {
      postGuidesWith({ orders, trip_type }).then((res) => {
        this.all = res.data
        this.list = this._splitArray(this._filter(this.all), 2)
      })
    },
    handleRowClick(row) {
      if (row.can_assign) this.guide_id = row.id
    },
    /**
     * @description: 确认派单
     * @return {*}
     */
    handleGuide() {
      const { orders, guide_id, trip_type } = this
      postGuidesAssign({ orders, guide_id, trip_type }).then(() => {
        this.guide_id = null
        if (this.$parent.clearSelections) {
          this.$parent.clearSelections()
        }
        // this.fetchData()
        this.$parent.fetchData()
        this.$parent.$notify({
          title: '成功',
          message: '指派导游成功',
          type: 'success'
        })
      })
    }
  },
  watch: {
    orders: {
      immediate: true,
      handler(value) {
        if (value.length > 0) this.fetchData(value, this.trip_type)
      }
    },
    keyword() {
      this.list = this._splitArray(this._filter(this.all), 2)
    }
  }
}
</script>
<style lang="less" scoped>
.guides-table {
  display: flex;
  justify-content: space-between;
  .el-table--border:first-child {
    border-right: none;
  }
}
::v-deep .el-radio__label {
  display: none;
}

.p-disabled {
  color: #999;
}
.btn {
  height: 40px;
  font-weight: bold;
  width: 200px;
  margin: 10px auto 0;
  display: block;
}
</style>
